import { BerechnungsartDurchschnitt } from '@/domain/mitarbeiter/features/anlageassistent/content/Zusammenfassung/Bezahlung/BerechnungsartDurchschnitt';
import { BerechnungsartExakt } from '@/domain/mitarbeiter/features/anlageassistent/content/Zusammenfassung/Bezahlung/BerechnungsartExakt';
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { useTranslation } from 'react-i18next';

export function StundenpensumMonat() {
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();
  const data = form.state.values;

  return (
    <>
      <span>
        {t(
          'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.stundenpensum.label',
        )}
      </span>

      <span className="text-neutrals-900 font-semibold">
        {t(
          'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.stundenpensum.options.monat',
        )}
      </span>
      {data.bezahlung.arbeitszeitkonto.gehaltsempfaenger.berechnungsartMonat ===
        'durchschnitt' && <BerechnungsartDurchschnitt />}
      {data.bezahlung.arbeitszeitkonto.gehaltsempfaenger.berechnungsartMonat ===
        'exakt' && <BerechnungsartExakt />}
    </>
  );
}
